import React from "react";
import styled from "@emotion/styled";
import colors from '../../../sass/brand_palette.scss';

var bottom = '0px',
    topArrow = '-10px',
    transformArrow = 'none';

const TooltipContainer = styled.div`
    position: absolute;
    border: 1px solid white;
    display:inline-block;
    white-space:${( {noLineBreak} ) => {
        let space = noLineBreak ? 'pre' : 'unset';
        return `${space}`;
    }};
    max-width: ${( {maxWidth} ) => { maxWidth ? maxWidth : '300px'}};
    width: ${( {maxWidth} ) => {
        let width = maxWidth ? maxWidth : 'auto';
        return width;
    }};
    z-index: 200;
    visibility: ${( {position} ) => {
        let left = position !== 'bottom' ? 'hidden' : 'visible';
        return `${left}`;
    }};
`;

const TooltipArrow = styled.div`
    content: ' ';
    width: 0;
    height: 0;
    border-right: 10px solid transparent;
    border-bottom: 10px solid ${colors.blue1};
    border-left: 10px solid transparent;
    top: ${topArrow};
    position: absolute;
`;

export class Tooltip extends React.Component {
    constructor(props) {
        super(props);
        
        this.tooltipRef = React.createRef();
        this.tooltipArrowRef = React.createRef();
        
        this.state = {
            content: null,
            style: {}
        };
    }
    
    onMouseEnter = () => {
        this.setState({
            content: <TooltipContainer
            ref={this.tooltipRef}
            noLineBreak={this.props.noLineBreak}
            maxWidth={this.props.maxWidth}
            key="tooltip"
            position={this.props.position}
            className={this.props.tooltipClassName ? this.props.tooltip.className : "bg-blue1 border-radius-default text-center white p-3"}>
            <div dangerouslySetInnerHTML={{__html: this.props.show}} />
            <TooltipArrow ref={this.tooltipArrowRef}/>
            </TooltipContainer>
            
        });
        
        this.setStyle();
    }
    
    onMouseLeave = () => { 
        this.setState({
            content: null
        });
    }
    
    setStyle = () => {
        if(!this.tooltipRef.current){
            var $component = this;
        
            setTimeout(function($component){
                $component.setStyle();
            },10,$component);
            
            return;
        }

        var position = this.props.position ? this.props.position : 'top',
            left = 0 - (this.tooltipRef.current.offsetWidth/2) + (this.tooltipRef.current.offsetParent.offsetWidth/2) + 'px',
            leftArrow = 'calc(50% - 10px)',
            tooltipHeight = this.tooltipRef.current.offsetHeight,
            parentHeight = this.tooltipRef.current.offsetParent.offsetHeight;
        
        switch(position){
            case 'top':
                topArrow = (tooltipHeight-2) + 'px';
                transformArrow = 'rotate(180deg)';
                bottom = (parentHeight+10) + 'px';
                break;
            case 'bottom':
                topArrow = (tooltipHeight-2) + 'px';
                transformArrow = '';
                bottom = 0 + 'px';
                break;
            case 'left':
                
                break;
            case 'right':
                
                break;    
        }
        
        //this.tooltipRef.current.style.top = top;
        this.tooltipRef.current.style.bottom = bottom;
        this.tooltipRef.current.style.left = left;
        this.tooltipRef.current.style.visibility = 'visible';
        this.tooltipArrowRef.current.style.left = leftArrow;
        this.tooltipArrowRef.current.style.top = topArrow;
        this.tooltipArrowRef.current.style.transform = transformArrow;
    }
    
    render(){ 
        return(
            <div className={(this.props.className ? this.props.className : '')} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                {this.props.html}
                {this.state.content}
            </div>
        );
    }
}


